import DeleteIcon from '@mui/icons-material/Delete';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import { useModal } from 'mui-modal-provider';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { useDeleteGroupList } from '../../../../sic-lib/api/hooks/useGroupsList';
import { ListItem } from '../../../../sic-lib/types/Lists';
import DialogConfirmAction from '../../../Shared/DialogConfirmAction/DialogConfirmAction';
import IconButtonLoading from '../../../Shared/IconButtonLoading/IconButtonLoading';

const useStyles = makeStyles()((theme: Theme) => ({
    button: {
        marginLeft: theme.spacing(1),
    },
}));

interface Props {
    list: ListItem;
}

export default function DeleteGroup({ list }: Props) {
    const { showModal } = useModal();
    const { classes } = useStyles();
    const history = useHistory();
    const { mutate, isLoading } = useDeleteGroupList();

    const handleDelete = () => {
        const modal = showModal(DialogConfirmAction, {
            title: 'Delete Group',
            description: 'This group will be permanently deleted',
            onConfirm: async () => {
                mutate(list.listId);
                history.replace('/contacts/-1');
            },
            onCancel: () => {
                modal.hide();
            },
        });
    };

    return (
        <Grid item xs={true}>
            <Grid className={classes.button}>
                <IconButtonLoading
                    tooltip="Delete Group"
                    showLoading={isLoading}
                    onClick={handleDelete}
                >
                    <DeleteIcon />
                </IconButtonLoading>
            </Grid>
            {/*<Tooltip title='Delete Group'>
                <IconButton
                    onClick={handleOpen}
                    className={classes.button}
                >
                    <DeleteIcon />
                </IconButton>
            </Tooltip>*/}
        </Grid>
    );
}
